function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Checkmark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "CheckmarkIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "m10.14 18.412-.014.014L3.771 12a1.734 1.734 0 0 1 .007-2.445c.67-.67 1.756-.67 2.425 0l.007.007 3.895 3.937 7.486-7.486a1.75 1.75 0 0 1 2.475 2.474l-9.925 9.925z"
    })
  }));
});
Checkmark.displayName = 'CheckmarkIcon';
export default Checkmark;